/**
 * Blokada viewportu pod klawiaturą ekranową (#1800).
 *
 * Objaw: na telefonie po kliknięciu w pole formularza pojawiała się klawiatura,
 * a stronę dawało się przewinąć DUŻO za daleko w górę — nad kartą zostawała pusta
 * przestrzeń i wyglądało to, jakby aplikacja się rozjeżdżała.
 *
 * Przyczyna: karta to `position: fixed` o wysokości `100dvh`, czyli wysokości
 * LAYOUT viewportu. Klawiatura domyślnie zmniejsza tylko VISUAL viewport
 * (`interactive-widget=resizes-visual`), więc karta zostaje wysoka na cały ekran,
 * a przeglądarka pozwala przesuwać po niej okienko podglądu.
 *
 * Warstwa 1 (podstawowa) to `interactive-widget=resizes-content` w <meta viewport>
 * — załatwia Chrome/Edge na Androidzie, bo tam klawiatura kurczy layout viewport.
 * Ten moduł jest warstwą 2 dla iOS Safari, które `interactive-widget` ignoruje:
 * przepisujemy realną wysokość i przesunięcie visual viewportu do zmiennych CSS.
 *
 * Zmienne ustawiamy TYLKO gdy klawiatura faktycznie zasłania ekran — poza tym
 * stanem czyścimy je i wracamy do czystego `100dvh`, żeby nie ruszać desktopu
 * i nie wprowadzać drgań przy zwykłym przewijaniu.
 */

/** Poniżej tego progu (px) różnicę uznajemy za pasek adresu, a nie klawiaturę. */
const KEYBOARD_THRESHOLD = 120;

export const installViewportLock = () => {
  const vv = window.visualViewport;

  if (!vv) {
    return;
  }

  const el = document.documentElement;

  const apply = () => {
    // Pinch-zoom kurczy visual viewport dokładnie tak samo jak klawiatura, a formularz
    // pozwala na zoom (brak user-scalable=no). Przy powiększeniu przejęlibyśmy sterowanie
    // wysokością i pozycją karty, a ta zaczęłaby uciekać przy każdym przesunięciu kadru —
    // więc w stanie powiększenia po prostu oddajemy pole przeglądarce.
    if (vv.scale > 1) {
      el.style.removeProperty("--app-h");
      el.style.removeProperty("--app-top");
      return;
    }

    const hidden = window.innerHeight - vv.height;

    if (hidden > KEYBOARD_THRESHOLD) {
      el.style.setProperty("--app-h", `${vv.height}px`);
      el.style.setProperty("--app-top", `${vv.offsetTop}px`);
    } else {
      el.style.removeProperty("--app-h");
      el.style.removeProperty("--app-top");
    }
  };

  apply();

  vv.addEventListener("resize", apply);
  vv.addEventListener("scroll", apply);
  window.addEventListener("orientationchange", apply);
};
